import styled from 'styled-components';

export const Filler = styled.div`
    color:red;
    background:transparent;
    height:230vh;
    position:relative;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    z-index:-100;
`
export const AboutSection = styled.div`
position: absolute;
top:120vh;
color:white;
font-size:5rem;
text-align: center;
`